// @file Helper for TA-related logic, e.g. links
import environment from '@@/bits/environment'

export const getPadletTaUrl = (): string => {
  return environment === 'development' ? 'https://ta.padlet.dev' : 'https://ta.padlet.com'
}

// Campaign -- Identifies a specific product promotion or strategic campaign.
const UTM_CAMPAIGN = 'promote_ta_on_padlet_app'

// Identifies what type of link was used, such as email or pay-per-click advertising.
const UTM_MEDIUM_MAPPING = {
  dashboard: 'padlet_com_app_nav_dashboard',
  home: 'padlet_com_app_nav_home',
  home_footer: 'padlet_com_app_nav_home_footer',
}

// Identifies what specifically was clicked to bring the user to the site
const UTM_CONTENT_MAPPING = {
  mobile: 'padlet_com_nav_mobile',
  desktop: 'padlet_com_nav_desktop',
  agnostic: 'padlet_com_nav',
}

export function getTaUrlWithUtmParams(
  context: 'dashboard' | 'home' | 'home_footer',
  isMobile: boolean | null, // true, false, null
  isLoggedIn = false,
): string {
  const utmMedium = UTM_MEDIUM_MAPPING[context]
  const utmContent = UTM_CONTENT_MAPPING[isMobile === null ? 'agnostic' : isMobile ? 'mobile' : 'desktop']

  // We use utm_medium for context (dashboard, home, home_footer)
  // We use utm_content for mobile or desktop or agnostic (null)
  const searchParams = new URLSearchParams({
    utm_source: `padlet_com_${environment}`, // padlet_com_development, padlet_com_staging, padlet_com_production
    utm_medium: utmMedium,
    utm_campaign: UTM_CAMPAIGN,
    utm_content: utmContent,
  })

  // `logged_in=true` allows ta.padlet.com to get session from padlet.com and automatically log the user in
  // If the user is not logged in (e.g. on landside), it'll redirect the user to padlet.com/auth/login which is not what we want
  if (isLoggedIn) {
    searchParams.append('logged_in', 'true')
  }

  return `${getPadletTaUrl()}?${searchParams.toString()}`
}
